import BaseComponent from '../../js/base-component';
import contentBlocker from '../../js/content-blocker';

export default class Sidemenu extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.trigger = this.refs.trigger;
        this.menu = this.refs.menu;

        this._onClickTrigger = this._onClickTrigger.bind(this);
    }

    static getRequiredRefs() {
        return ['trigger', 'menu'];
    }

    init() {
        this._addListeners();
    }

    _addListeners() {
        this.trigger.addEventListener('click', this._onClickTrigger);
    }

    _onClickTrigger(e) {
        this.menu.classList.toggle('is-opened');
        if(contentBlocker.isBlocked('header')){
            contentBlocker.unblock('header');
        }else {
            contentBlocker.block('header');
        }
    }

    onDestroy(){
        this.trigger.removeEventListener('click', this._onClickTrigger);
    }

}
